import styled from "styled-components";
import { Skeleton } from "@mui/material";

import { Option } from "../../../components/public/simsFilter";

export const Wrapper = styled.section`
  .select-grade {
    min-width: 320px;
    font-size: var(--font-size-sm);
    border-radius: 12px;
    box-shadow: 5px 10px 30px rgba(101, 183, 225, 0.2);
    @media screen and (max-width: 375px) {
      font-size: var(--font-size-xs);
      min-width: 100%;
    }
  }
  .personal-card-purchase {
    transition: all ease 0.5s;
    svg {
      pointer-events: none;
    }
    &:hover {
      width: 210px;
      height: 240px;
      transition: all ease 0.5s;
      background: var(--tertiary-color);
      border: 1px solid var(--primary-color);
      box-shadow: var(--box-shadow2);
      .before-discount,
      .after-discount,
      .currency-price,
      h3 {
        color: var(--white-color);
      }
      h3 {
        font-size: var(--font-size-md);
      }
      button {
        color: var(--tertiary-color);
        background: var(--secondary-color);
      }
    }
  }
`;
export const StyledValueAddedTax = styled.p`
  font-weight: 300;
  font-size: var(--font-size-sm);
  color: var(--blue-color-dark);
  @media screen and (max-width: 576px) {
    font-weight: 400;
    font-size: var(--font-size-xs);
  }
`;
export const StyledOption = styled(Option)`
  input[type="checkbox"] {
    display: none;
  }
`;
export const StyledSkeleton = styled(Skeleton)`
  border-radius: 16px;
`;
